import { Task } from '../../types';
import { getFlexiblePrecision, getFlexibleRange, normalizeFlexibleDate } from './scheduleUtils';

type Precision = NonNullable<Task['schedule']>['precision'];

export const getFlexibleEndDateFromInterval = (start: Date, precision: Precision, interval: number) => {
    const end = new Date(start);
    const length = Math.max(1, interval);
    if (precision === 'day') end.setDate(end.getDate() + length - 1);
    else if (precision === 'month') end.setMonth(end.getMonth() + length - 1, 1);
    else end.setFullYear(end.getFullYear() + length - 1, 0, 1);
    return normalizeFlexibleDate(end, precision);
};

export const getFlexibleIntervalFromDates = (start: Date, end: Date, precision: Precision) => {
    if (precision === 'day') return Math.max(1, Math.round((end.getTime() - start.getTime()) / 86_400_000) + 1);
    if (precision === 'month') {
        return Math.max(1, (end.getFullYear() - start.getFullYear()) * 12 + end.getMonth() - start.getMonth() + 1);
    }
    return Math.max(1, end.getFullYear() - start.getFullYear() + 1);
};

export const getFlexibleIntervalForTask = (task: Task) => {
    const precision = getFlexiblePrecision(task);
    if (!precision || !task.dueDate) return 1;
    const { start, end } = getFlexibleRange(task);
    return getFlexibleIntervalFromDates(start, end, precision);
};
